import React from 'react'
import Swal from "sweetalert2";
import { SERVER_URL } from '../../../ServerUrl';
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from 'react-router-dom';
import axios from 'axios';
import { ResetBookingInfo, SetCompletedBooking } from '../../../actions/bookings';
import { updateOperatorWalletBalance } from '../../../Redux/userReducer';

const PackageBooking = ({ bookingDetail, couponResponse, loggedUserId, walletPay, setSavebooking }) => {
    const history = useHistory()
    const dispatch = useDispatch();

    console.log(bookingDetail, "packbookingDetailpack")

    const saveInfo = async (e) => {
        e.preventDefault();
        setSavebooking(true)
        // Create a new FormData object
        const formData = new FormData();
        if (loggedUserId) { formData.append("userId", loggedUserId) };
        formData.append("email", bookingDetail.email);
        formData.append("phone", bookingDetail.phone);
        formData.append("NoOfpassengers", bookingDetail.NoOfpassengers);
        bookingDetail?.passengerDetails?.forEach((passenger, index) => {
            formData.append(`passengerDetails[${index}][firstName]`, passenger.firstName);
            formData.append(`passengerDetails[${index}][middleName]`, passenger.middleName);
            formData.append(`passengerDetails[${index}][lastName]`, passenger.lastName);
            formData.append(`passengerDetails[${index}][gender]`, passenger.gender);
            formData.append(`passengerDetails[${index}][dob]`, passenger.dob);
            formData.append(`passengerDetails[${index}][passportNumber]`, passenger.passportNumber);
            formData.append(`passengerDetails[${index}][country]`, passenger.country);

            // Append image file if available
            if (passenger.image) {
                formData.append(`passengerDetails[${index}][image]`, passenger.image);
            }
        });
        formData.append("totalFare", bookingDetail.totalFare);
        formData.append("totalPaidAmount", bookingDetail.totalPaidAmount);
        formData.append("DiscountedAmount", couponResponse.totalDiscount);
        formData.append("couponType", couponResponse.couponType);
        // formData.append("cashbackType", cashbackType);
        formData.append("type", bookingDetail.type);
        formData.append("paymentMethod", bookingDetail.paymentMethod);
        formData.append("ispaymentdone", bookingDetail.ispaymentdone);
        formData.append("bookedBy", bookingDetail.bookedBy);
        formData.append("totalCashbackDiscount", bookingDetail.totalCashbackDiscount);
        formData.append("totalPriceDiscount", bookingDetail.totalPriceDiscount);
        formData.append("walletPay", walletPay);
        formData.append("packageWithAccom", bookingDetail.packageWithAccom);
        formData.append("packageId", bookingDetail.packageId);
        bookingDetail.tripDetails.forEach((trip, index) => {
            formData.append(`tripDetails[${index}][tripType]`, trip.tripType);
            formData.append(`tripDetails[${index}][trip]`, trip.tripId);
            formData.append(`tripDetails[${index}][noOfSeats]`, trip.noOfSeats);
            formData.append(`tripDetails[${index}][originalPrice]`, trip.originalPrice);
            formData.append(`tripDetails[${index}][totalCouponDiscount]`, trip.totalCouponDiscount);
            formData.append(`tripDetails[${index}][cashbackDiscount]`, trip.cashbackDiscount);
            if (trip.seats && trip.seats.length > 0) {
                trip.seats.forEach((seat, seatIndex) => {
                    formData.append(`tripDetails[${index}][seats][${seatIndex}]`, seat);
                });
            } else {
                // Send empty array as a JSON string if seats is empty
                formData.append(`tripDetails[${index}][seats]`, JSON.stringify([]));
            }
            if (trip.appliedCoupons && trip.appliedCoupons.length > 0) {
                trip.appliedCoupons.forEach((coupon, cIndex) => {
                    formData.append(`tripDetails[${index}][appliedCoupons][${cIndex}][code]`, coupon.code);
                    formData.append(`tripDetails[${index}][appliedCoupons][${cIndex}][couponType]`, coupon.couponType);
                    formData.append(`tripDetails[${index}][appliedCoupons][${cIndex}][percentage]`, coupon.percentage);
                    formData.append(`tripDetails[${index}][appliedCoupons][${cIndex}][amount]`, coupon.amount);
                });
            } else {
                formData.append(`tripDetails[${index}][appliedCoupons]`, JSON.stringify([]));
            }
            formData.append(`tripDetails[${index}][price]`, trip.price);
        });

        // Append each passenger in the passengerDetails array


        try {
            const response = await axios.post(`${SERVER_URL}/bookings/book-package`, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });
            Swal.fire({
                icon: "Success",
                title: "Success",
                text: response?.data?.messages?.mainMessage,
            });
            console.log("Data successfully saved:", response.data);
            await dispatch(SetCompletedBooking(response?.data?.booking));
            sessionStorage.setItem('bookingDetails', JSON.stringify(response?.data?.booking));
            dispatch(ResetBookingInfo());
            setSavebooking(false)
            if (response?.data?.updatedWalletBalance) { dispatch(updateOperatorWalletBalance(response?.data?.updatedWalletBalance)) }
            history.push('/client/order-invoice', {
                mainMessage: response?.data?.messages,
                backHome: 1
            });
        } catch (error) {
            Swal.fire({
                icon: "error",
                title: "error",
                text: error,
            });
            setSavebooking(false)
            console.error("Error saving data:", error);
        }
    };



    return (
        <>
            <button
                onClick={saveInfo}
                className="payBtn"
            >
                {walletPay ? "Create Booking" : "Proceed to pay "}
            </button>
        </>
    )
}

export default PackageBooking
